import React from "react";
import "./SkeletonLoaderBlogPage.css";

const SkeletonLoaderBlogPage = () => {
  return (
    <div className="container-fluid skeleton-blog-page">
      <div className="row">
        {/* Main Blog Section */}
        <div className="col-lg-8 col-md-12">
          {Array.from({ length: 3 }).map((_, index) => (
            <div key={index} className="skeleton-blog">
              <div className="skeleton-blog-image" />
              <div className="skeleton-blog-title" />
              <div className="skeleton-blog-info">
                <div className="skeleton-info-item" />
                <div className="skeleton-info-item" />
              </div>
              <div className="skeleton-blog-content">
                <div className="skeleton-paragraph" />
                <div className="skeleton-paragraph" />
                <div className="skeleton-read-more" />
              </div>
            </div>
          ))}

          {/* Pagination Skeleton */}
          <div className="skeleton-pagination">
            {Array.from({ length: 5 }).map((_, index) => (
              <div key={index} className="skeleton-pagination-item" />
            ))}
          </div>
        </div>

        {/* Sidebar Section */}
        <div className="col-lg-4 col-md-12">
          {/* Search Widget Skeleton */}
          <div className="skeleton-card">
            <div className="skeleton-card-body">
              <div className="skeleton-search-input" />
              <div className="skeleton-search-button" />
            </div>
          </div>

          {/* Latest Posts Widget Skeleton */}
          <div className="skeleton-card">
            <div className="skeleton-card-header" />
            <div className="skeleton-card-body">
              {Array.from({ length: 3 }).map((_, index) => (
                <div key={index} className="skeleton-latest-post">
                  <div className="skeleton-post-thumb" />
                  <div className="skeleton-post-info">
                    <div className="skeleton-post-title" />
                    <div className="skeleton-post-date" />
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Categories Widget Skeleton */}
          <div className="skeleton-card">
            <div className="skeleton-card-header" />
            <div className="skeleton-card-body">
              {Array.from({ length: 5 }).map((_, index) => (
                <div key={index} className="skeleton-category" />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkeletonLoaderBlogPage;
